module.exports = __webpack_public_path__ + "static/media/logo_white.6f9c4755.png";